// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"4ad82734","130":"49899232","374":"4f879d04","874":"a3989ce6"}[chunkId] + ".css";
};